
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default function(node, props) {
  return tippy(node, props);
}

